import { Button, TableItem, TableMessage } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { useNewWindowNavigate } from 'hooks/useNewWindowNavigate';
import { t } from 'i18next';
import { PiNavigationArrow, PiPlus, PiTrash } from 'react-icons/pi';
import { IClientAccountForm } from 'services/client-account/types';
import { useGetVideoLightList } from 'services/video/light';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const ClientAccountVideo = () => {
  const videoLightList = useGetVideoLightList();
  const { values, setFieldValue, status } =
    useFormikContext<IClientAccountForm>();

  const navigateToNewWindow = useNewWindowNavigate();

  const videoOptions = (videos: string[]) =>
    videoLightList.data
      ?.filter(video => !videos.includes(video.id))
      .map(video => ({
        label: `${video.mainTitle ?? ''}`,
        value: video.id,
      })) ?? [];

  const goToVideo = (id: string) => {
    navigateToNewWindow(`video/${id}`);
  };

  return (
    <Table
      displayMode
      data={{
        nodes:
          values.videos?.map((video, key) => ({
            id: key,
            value: video.id,
            label: `${video.name ?? ''}`,
          })) ?? [],
      }}
      columns={[
        {
          label: t('input.label.video'),
          renderCell: ({ label, value, id }) => (
            <TableItem>
              {status?.displayMode ? (
                <TableItem.Text text={label} />
              ) : (
                <FormInput.Select
                  name={`videos[${id}].id`}
                  label={t('input.label.video')}
                  options={videoOptions(
                    values.videos?.map(video => video.id) ?? []
                  )}
                  onChange={option => {
                    setFieldValue(`videos[${id}].id`, option.value);
                    setFieldValue(`videos[${id}].name`, option.label);
                  }}
                  value={{ label: label ?? '-', value: value }}
                />
              )}
            </TableItem>
          ),
        },
        {
          label: '',
          renderCell: ({ value }) => (
            <TableItem justifyPosition='end'>
              {status?.displayMode ? (
                <Button isClear onlyIcon onClick={() => goToVideo(value)}>
                                    <Button.Description description={t('button.open')} />

                                    <Button.Icon
                    icon={<PiNavigationArrow transform='scale(-1,1)' />}
                  />
                </Button>
              ) : (
                <Button
                  variant={BUTTON_VARIANT.remove}
                  isClear
                  onlyIcon
                  onClick={() =>
                    setFieldValue(
                      `videos`,
                      values.videos?.filter(video => video.id !== value)
                    )
                  }>
                                    <Button.Description description={t('button.remove')} />

                                    <Button.Icon icon={<PiTrash />} />
                </Button>
              )}
            </TableItem>
          ),
        },
      ]}
      tableOptions={
        status?.displayMode
          ? undefined
          : {
              renderAfterTable: () => (
                <tfoot className='full-width-footer'>
                  <TableMessage
                    className='cursor-pointer'
                    disable={
                      values.videos?.length
                        ? !values.videos[values.videos.length - 1]?.id.length
                        : false
                    }
                    onClick={() =>
                      setFieldValue(`videos[${values.videos?.length ?? 0}]`, {
                        id: '',
                        name: '',
                      })
                    }>
                    <TableItem.Text text={t('button.add')} />
                    <PiPlus />
                  </TableMessage>
                </tfoot>
              ),
            }
      }
      size='compact'
    />
  );
};

export default ClientAccountVideo;
